import React from 'react';

// Utils

import styles from './Input.module.scss';

import classNames from 'classnames';
import IconChevron from "src/components/icons/IconChevron";
import {useDimensions} from "src/hooks/useDimensions";

const noop = () => {
};

const Input = React.forwardRef(({
                                    name,
                                    value,
                                    type,
                                    readOnly = false,
                                    onChange = noop,
                                    className = '',
                                    style = null,
                                    wrapperClassName = '',
                                    beforeContent = null,
                                    afterContent = null,
                                    error = false,
                                    success = false,
                                    disabled = false,
                                    variant = '',
                                    border = '',
                                    options = [],
                                    selectOptionsRenderer = (args) => (args),
                                    ...props
                                }, ref) => {
    const inputValue = type === 'checkbox'
        ? {checked: value}
        : {value};

    const wrapper = (input) => (
        <div
            className={classNames(
                styles.input__container, error && styles.error, success && styles.success,
                variant && styles[`variant-${variant}`], border && styles[`variant-border-${border}`],
                type && styles[`type-${type}`], readOnly && styles.readOnly, disabled && styles.disabled,
                wrapperClassName
            )}
        >
            {beforeContent && <span className={styles.input__extra_content}>{beforeContent}</span>}
            {input}
            {afterContent && <span className={styles.input__extra_content}>{afterContent}</span>}
        </div>
    );

    let input = (
        <input
            ref={ref}
            name={name}
            type={type}
            disabled={disabled}
            {...inputValue}
            onChange={onChange}
            className={classNames(className, styles.input, variant && styles[`variant-${variant}`],
                error && styles.error, success && styles.success
            )}
            style={style}
            {...props}
            readOnly={readOnly}
        />
    )

    if (type === 'checkbox') {
        return input;
    } else if (type === "select") {
        if (afterContent === null) {
            afterContent = <IconChevron rotation="down"/>
        }
        input = (
            <select
                ref={ref}
                name={name}
                {...inputValue}
                onChange={onChange}
                className={classNames(className, styles.input, variant && styles[`variant-${variant}`], error && styles.error, success && styles.success)}
                style={style}
                {...props}
            >
                {options.map(op => <option key={op} name={op} value={op}>{selectOptionsRenderer(op)}</option>)}
            </select>
        )
        //return input
    }
    // else
    return wrapper(input);

});

export default Input;
